module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_le_11_22_05_on.2549e90e.svg";